import { useContext } from "react";
import { PageActions, PageContextDispatch } from "./PageContext";

export function usePageActions(): PageActions {
    return useContext(PageContextDispatch)!;
};

export default usePageActions;
